import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import '../Motorrad.css';
import { Link } from 'react-router-dom';

import MotorradHeader from '../components/MotorradHeader'; 
import MotorradFooter from '../components/MotorradFooter';

const Motorrad = () => {
    const [activeTab, setActiveTab] = useState('M');
    const CATEGORIES = ['M', 'Sport', 'Tour', 'Roadster', 'Adventure'];
    const navigate = useNavigate();

    const handleNavigate = (path) => {
        navigate(path);
    };

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const motoData = {
        'M': [
            { id: 101, slug: 'm-1000-rr', name: 'BMW M 1000 RR', bgName: 'M 1000\nRR', image: '/assets/moto_models/M1000RR/BMW_M1000RR_1.png' },
            { id: 102, name: 'BMW M 1000 R', bgName: 'M 1000\nR', image: '/assets/moto_models/M1000R/BMW_M1000R_1.png' },
            { id: 103, name: 'BMW M 1000 XR', bgName: 'M 1000\nXR', image: '/assets/moto_models/M1000XR/BMW_M1000XR_1.png' },
        ],
        'Sport': [
            { id: 201, name: 'BMW S 1000 RR', bgName: 'S 1000\nRR', image: '/assets/moto_models/S1000RR/BMW_S1000RR_1.png' },
            { id: 202, name: 'BMW S 1000 XR', bgName: 'S 1000\nXR', image: '/assets/moto_models/S1000XR/BMW_S1000XR_1.png' },
        ],
        'Tour': [
            { id: 301, name: 'BMW R 1300 RT', bgName: 'R 1300\nRT', image: '/assets/moto_models/R1300RT/BMW_R1300RT_1.png' },
        ],
        'Roadster': [
            { id: 401, name: 'BMW S 1000 R', bgName: 'S 1000\nR', image: '/assets/moto_models/S1000R/BMW_S1000R_1.png' },
            { id: 402, name: 'BMW F 900 R', bgName: 'F 900\nR', image: '/assets/moto_models/F900R/BMW_F900R_1.png' },
        ],
        'Adventure': [
            { id: 501, name: 'BMW R 1300 GS', bgName: 'R 1300\nGS', image: '/assets/moto_models/R1300GS/BMW_R1300GS_1.png' },
            { id: 502, name: 'BMW R 1300 GS Adventure', bgName: 'R 1300\nGS Adventure', image: '/assets/moto_models/R1300GS Adventure/BMW_R1300GS_Adventure_1.png' },
            { id: 503, name: 'BMW F 450 GS', bgName: 'F 450\nGS', image: '/assets/moto_models/F450GS/BMW_F450GS_1.png' },
        ]
    };



    const activeIndex = CATEGORIES.indexOf(activeTab);
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 992);

    const heroStyle = {
        backgroundImage: `linear-gradient(rgba(0,0,0,0.2), rgba(0,0,0,0.2)), url(${
            process.env.PUBLIC_URL + (isMobile ? '/assets/vertical/header-bg_vertical.jpg' : '/assets/horizontal/motorrad_bg.jpg')
        })`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat'
    };

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 992);
        };
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return (
        <div className="motorrad-page">
            {/* ВСТАВЛЯЕМ ПОДКЛЮЧЕННЫЙ ХЕДЕР В САМОЕ НАЧАЛО */}

            <section className="motorrad-hero" style={heroStyle}>
                <div className="hero-content">
                    <h1>BMW R 1300 GS</h1>
                    <p>СОЗДАН ДЛЯ ПРИКЛЮЧЕНИЙ.</p>
                    <button className="btn-outline"> <Link to={`/moto_models`}>УЗНАТЬ БОЛЬШЕ</Link></button>
                </div>
            </section>

            <section className="models-section">
                <div className="models-header">
                    <h2>МОДЕЛЬНЫЙ РЯД</h2>
                    <ul className="models-filter">
                        {CATEGORIES.map((tab) => (
                            <li
                                key={tab}
                                className={activeTab === tab ? 'active' : ''}
                                onClick={() => setActiveTab(tab)}
                            >
                                {tab}
                            </li>
                        ))}
                    </ul>
                </div>

                <div className="models-slider-viewport">
                    <div 
                        className="slider-track" 
                        style={isMobile ? {} : { transform: `translateX(-${activeIndex * 100}%)` }}
                    >
                        {CATEGORIES.map((catName) => (
                            <div 
                                key={catName} 
                                className={`category-slide ${activeTab === catName ? 'mobile-active' : ''}`}
                            >
                                <div className="models-grid">

                                    {/* Левая колонка */}
                                    <div className="grid-column-left">
                                        {(motoData[catName] || []).slice(0, 2).map((model, index) => (
                                            <div key={model.id} className={`model-card ${index === 0 ? 'large-height' : 'small-height'}`}>
                                                <div className="card-bg-content">
                                                    <span className="model-series-vertical">{catName}</span>
                                                    <span className="model-name-bg">
                                                        {model.bgName.split('\n').map((line, i) => (
                                                            <React.Fragment key={i}>{line}<br /></React.Fragment>
                                                        ))}
                                                    </span>
                                                </div>


                                                {/* ОБОРАЧИВАЕМ КАРТИНКУ В ССЫЛКУ НА СТРАНИЦУ МОДЕЛИ */}
                                                <Link to={`/moto_models`} className="model-image-link"> {/* /motorrad/model/${model.slug} */}
                                                    <img src={model.image} alt={model.name} />
                                                </Link>

                                                <div className="model-info">

                                                {/* Также можно обернуть заголовок для удобства клика */}
                                                 <Link to={`/motorrad/model/${model.slug}`} style={{ textDecoration: 'none', color: 'inherit' }}>
                                                    <h3>{model.name}</h3>
                                                </Link>

                                                </div>
                                            </div>
                                        ))}
                                    </div>

                                    {/* Правая колонка */}
                                    <div className="grid-column-right">
                                        {(motoData[catName] || []).slice(2, 4).map((model) => (
                                            <div key={model.id} className="model-card equal-height">
                                                <div className="card-bg-content">
                                                    <span className="model-series-vertical">{catName}</span>
                                                    <span className="model-name-bg">
                                                        {model.bgName.split('\n').map((line, i) => (
                                                            <React.Fragment key={i}>{line}<br /></React.Fragment>
                                                        ))}
                                                    </span>
                                                </div>

                                                {/* ОБОРАЧИВАЕМ КАРТИНКУ В ССЫЛКУ НА СТРАНИЦУ МОДЕЛИ */}
                                                <Link to={`/motorrad/model/${model.slug}`} className="model-image-link">
                                                    <img src={model.image} alt={model.name} />
                                                </Link>

                                                <div className="model-info">

                                                   <Link to={`/motorrad/model/${model.slug}`} style={{ textDecoration: 'none', color: 'inherit' }}>
                                                        <h3>{model.name}</h3>
                                                    </Link>

                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>

                <div className="models-button">
                    <Link to="/moto_models" className="btn-show-all">ПОКАЗАТЬ ВСЕ</Link>
                </div>
            </section>

            {/* РАЗДЕЛ СЕРВИСНЫХ КАРТОЧЕК */}
            <section className="motorrad-service-card">
                <div className="service-card dark-card" onClick={() => handleNavigate('/service-request')}>
                    <div className="card-overlay"></div>
                    <div className="service-card-content">
                         <h2 className="service-title">ЗАПИСЬ <br/><span className="outline-text">НА СЕРВИС</span></h2>
                         <button className="service-btn">ОСТАВИТЬ ЗАЯВКУ</button>
                    </div>
                    <img src="/assets/motorrad_cards/service-bg.jpg" alt="Service" className="card-bg-img" />    
                </div>

                <div className="service-card blue-card" onClick={() => handleNavigate('/test-drive')}>
                    <div className="service-card-content">
                        <h2 className="service-title">ЗАПИСЬ <br/> <span className="outline-text">НА ТЕСТ-ДРАЙВ</span></h2>
                        <button className="service-btn">ЗАПИСАТЬСЯ</button>
                    </div>
                    <img src="/assets/motorrad_cards/testdrive-bg.jpg" alt="Test Drive" className="card-bg-img" />
                </div>
            </section>
        </div>
    );
};

export default Motorrad;